import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Typography, Grid2 } from '@mui/material';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.default,
	},
	inner: {
		padding: theme.spacing(6, 3),
		width: theme.breakpoints.values.lg,
		maxWidth: '100%',
		margin: '0 auto',
	},
	media: {
		'& img': {
			width: '100%',
			height: 'auto',
		},
	},
}));

const UserFlows = (props) => {
	const { className, ...rest } = props;

	const classes = useStyles();

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<div className={classes.inner}>
				<Grid2 alignItems="center" container justifyContent="space-between">
					<Grid2 item size={6}>
						<Typography gutterBottom variant="h3">
							Complete User Flows
						</Typography>
						<Typography variant="subtitle2">
							Not just a set of tools, the package includes the
							most common use cases of user flows like User
							Management, Second Level Layout, and many more.
						</Typography>
					</Grid2>
					<Grid2 className={classes.media} item lg={4} md={6} xs={12}>
						<img
							alt="User flows"
							src="./images/presentation/user_flows.png"
						/>
					</Grid2>
				</Grid2>
			</div>
		</div>
	);
};

UserFlows.propTypes = {
	className: PropTypes.string,
};

export default UserFlows;
